import type { ReactNode } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

type NiyaazFormSectionProps = {
  title: string;
  action?: ReactNode;
  children: ReactNode;
};

export const NiyaazFormSection = ({ title, action, children }: NiyaazFormSectionProps) => (
  <Card variant="outlined" sx={{ width: "100%", minWidth: 0 }}>
    <CardContent sx={{ p: { xs: 2, sm: 3 }, "&:last-child": { pb: { xs: 2, sm: 3 } } }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "stretch", sm: "center" }}
        justifyContent="space-between"
        spacing={1.5}
        sx={{ mb: 2 }}
      >
        <Typography variant="subtitle1" component="h2" fontWeight={600}>
          {title}
        </Typography>
        {action ? <Stack direction="row">{action}</Stack> : null}
      </Stack>
      {children}
    </CardContent>
  </Card>
);
